/**
 * Display labels for the 10 reservation status values supported by the API.
 */
export const STATUS_LABELS = {
    pending: "En attente",
    accepted: "Accepté",
    declined: "Refusé",
    paid: "Payé",
    in_progress: "En cours",
    finish: "Terminé",
    refunded: "Remboursé",
    canceled: "Annulé",
    failed: "Échoué",
    awaiting_transfer: "Transfert en attente",
};

/** Chakra Badge colorScheme mapped to each reservation status. */
export const STATUS_SCHEME = {
    pending: "orange",
    accepted: "blue",
    declined: "red",
    paid: "green",
    in_progress: "purple",
    finish: "teal",
    refunded: "orange",
    canceled: "gray",
    failed: "red",
    awaiting_transfer: "yellow",
};

export const DEFAULT_STATUS_SCHEME = "gray";

/**
 * Picks the artist label for a reservation row from the enriched `artist` field.
 * Falls back to a derived ID label when the enrichment is missing.
 * @param {Object} reservation - Reservation object
 * @returns {string}
 */
export function pickArtistLabel(reservation) {
    if (reservation?.artist?.name) return reservation.artist.name;
    if (reservation?.artist_group_id) return `Groupe #${reservation.artist_group_id}`;
    if (reservation?.artist_owner_id) return `Artiste #${reservation.artist_owner_id}`;
    return "—";
}

/**
 * Picks the auditor label (full name + email) from the enriched auditor_pro field.
 * @param {Object} reservation - Reservation object
 * @returns {{ name: string, email: string }}
 */
export function pickAuditorLabel(reservation) {
    return {
        name: reservation?.auditor_pro?.name || (reservation?.auditor_who_reserve_id ? `User #${reservation.auditor_who_reserve_id}` : "—"),
        email: reservation?.auditor_pro?.email || "",
    };
}
